import { theme } from '@theme';
import { FC } from 'react';
import styled from 'styled-components';
import { formatStringAsPerLocale } from '../../../../services/utils/HelperFunctions';
import { Typography } from '../../../style';

type PaginationProps = {
  startIndex: number;
  endIndex: number;
  count: number;
  totalCount: number;
  textValue?: string;
  textFont?: number;
  textFontWeight?: number;
  textMarginTop?: number;
};

const ResultText: FC<PaginationProps> = (props) => {
  const lastOfferIndex = props.endIndex > props.count ? props.count : props.endIndex;

  const getResultText = (): string => {
    return props.textValue
      ? `${props.textValue} ${props.count > 0 ? props.startIndex + 1 : 0}-${lastOfferIndex}`
      : `${props.count > 0 ? props.startIndex + 1 : 0}-${lastOfferIndex} of ${props.count}`;
  };

  return (
    <Wrapper data-testid='result-text'>
      <Typography
        size={props.textFont ?? theme.typography.h5}
        fontWeight={props.textFontWeight ?? theme.typography.fontWeights.bold}
        className='-result'
        display='inline-block'
        color={theme.palette.basicGray}
        marginTop={props.textMarginTop ?? 3}
        marginLeft={0}
      >
        {getResultText()}
        {!props.textValue ? (
          <span className='-total-count'>
            {' '}
            (filtered from {formatStringAsPerLocale(props.totalCount.toString())})
          </span>
        ) : null}
      </Typography>
    </Wrapper>
  );
};

export default ResultText;

const Wrapper = styled.div`
    height: 30px;
    vertical-align: middle;
    margin-right: 5px;
    float: right!important
    margin-left: 5px;
    text-align:end;
    .-result {
        display: block;
        padding-top: 1%;
    }

    .-total-count {
        font-weight: normal;
    }
`;
